<template>
  <div>
    <vue-portal to="hrsys-navbar">
      <div class="flex text-2xl font-bold text-center">
        <base-back-button/>
        <base-header-title :title="$t('clients.client')"/>
      </div>
    </vue-portal>
    <base-loader :loading="loadingdata">
      <client-details-component
        :action="$t(`buttons.${[process]}`)"
        :client="clientData"
        :loading="loadingContent"
        @confirm="doClient"/>
    </base-loader>
  </div>
</template>

<script>
  import ClientDetailsComponent from "../../components/clients/ClientDetailsComponent"
  import Clients from "../../services/Clients"
  import BaseLoader from "../../components/_base-loader";

  export default {
    name: 'ClientDetails',
    components: {
      BaseLoader,
      ClientDetailsComponent
    },
    data () {
      return {
        clientData: {},
        clientId: null,
        loadingdata: false,
        loadingContent: false
      }
    },
    methods: {
      doClient () {
        if (this.process === 'update') {
          this.updateClient()
        } else {
          this.createClient()
        }
      },
      getClientDetails () {
        this.loadingdata = true;
        Clients.details(this.clientId).then((res) => {
          this.clientData = res.data
        }).catch((e) => {
          this.$notificationService.error(e.message)
        }).finally(() => this.loadingdata = false)
      },
      createClient () {
        this.loadingContent = true;
        Clients.create(this.clientData).then(() => {
          this.$notificationService.success(`${this.$t('clients.client')} ${this.$t('notification.successCreate')}`);
          this.$router.replace({name: 'clients'})
        }).catch((e) => {
          this.$notificationService.error(e.message)
        }).finally(() => {
          this.loadingContent = false
        })
      },
      updateClient () {
        this.loadingContent = true;
        Clients.update(this.clientData).then(() => {
          this.$notificationService.success(`${this.$t('clients.client')} ${this.$t('notification.successUpdate')}`)
        }).catch((e) => {
          this.$notificationService.error(e.message)
        }).finally(() => this.loadingContent = false)
      },
    },
    computed: {
      process () {
        return (this.clientId) ? 'update' : 'create'
      }
    },
    mounted () {
      this.clientId = parseInt(this.$route.params.id);
      if (this.process === 'update') {
        this.getClientDetails()
      }
    }
  }
</script>

<style scoped>

</style>
